import React from 'react';

import Grid from '@material-ui/core/Grid';

import Modal from '../../modal';

import { Container } from '../../styles';

export default function DeleteCoupon({
  openModal,
  coupon,
  setModal,
  deleteCoupon,
}) {
  return (
    <Modal
      isVisible={openModal}
      title="Remover Cupom"
      toggle={() => setModal(!openModal)}
      size="xs"
      buttonPrimary="manter cupom"
      buttonSecondary="remover permanentemente"
      modalActions={2}
      onSubmit={deleteCoupon}
      isDelete
    >
      <Container style={{ margin: '30px 0 0 0' }}>
        <Grid container justify="center" direction="column" alignItems="center">
          <Grid item>
            <span>Tem certeza que deseja remover o cupom<span style={{ fontWeight: 'bold' }}>{` ${coupon.name}`}</span>?</span>
          </Grid>

          <Grid item>
            <span>Esta ação não poderá ser desfeita.</span>
          </Grid>
        </Grid>
      </Container>
    </Modal>
  );
}
